/**
 * Search function for filtering cities by English or Arabic name
 * @param items - Array of cities to search through
 * @param searchTerm - Search term to filter by
 * @param limit - Maximum number of results to return (default: 50)
 * @returns Filtered array of cities
 */
export var searchCities = function searchCities(items, searchTerm) {
  var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 50;
  if (!searchTerm || searchTerm.trim() === "") {
    return items.slice(0, limit);
  }
  var normalizedSearch = searchTerm.toLowerCase().trim();
  var results = items.filter(function (city) {
    var _city$name_en, _city$name_ar;
    return ((_city$name_en = city.name_en) === null || _city$name_en === void 0 ? void 0 : _city$name_en.toLowerCase().includes(normalizedSearch)) || ((_city$name_ar = city.name_ar) === null || _city$name_ar === void 0 ? void 0 : _city$name_ar.toLowerCase().includes(normalizedSearch));
  });
  return limit ? results.slice(0, limit) : results;
};